const commentCounter = (myComment) => {
  const count = myComment.length ? myComment.length : 0;
  return count;
};

export default commentCounter;